import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { App } from '../app/App';

const HomePage = lazy(() => import('../pages/HomePage'));
const AboutPage = lazy(() => import('../pages/AboutPage'));
const ServicesPage = lazy(() => import('../pages/ServicesPage'));
const CaseStudiesPage = lazy(() => import('../pages/CaseStudiesPage'));
const ContactPage = lazy(() => import('../pages/ContactPage'));
const NotFoundPage = lazy(() => import('../pages/NotFoundPage'));

const page = (children: JSX.Element) => (
  <Suspense fallback={<div className="min-h-screen bg-surface px-6 py-24 text-center text-muted">Loading...</div>}>
    {children}
  </Suspense>
);

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: page(<HomePage />) },
      { path: 'about', element: page(<AboutPage />) },
      { path: 'services', element: page(<ServicesPage />) },
      { path: 'case-studies', element: page(<CaseStudiesPage />) },
      { path: 'contact', element: page(<ContactPage />) },
      { path: '*', element: page(<NotFoundPage />) },
    ],
  },
]);
